import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { PartnerDatabase } from "../../Sourcing/Partner/PartnerDatabase/PartnerDatabase";
import { PartnerDetails } from "../../Sourcing/Partner/PartnerDetails/PartnerDetails";
import { CustomerFeedback } from "../../AccountManagement/CustomerFeedback";
import { OrgRepo } from "../../AccountManagement/Organisation/OrgRepo";
import { OrgProfilePage } from "../../AccountManagement/Organisation/OrgprofilePage";
import { CompanyProfilePage } from "../../AccountManagement/Organisation/CompanyProfilePage";
import { CustomerRfqOR } from "../../AccountManagement/CustomerRFQ/CustomerRfq";
import { CURFQDetails } from "../../AccountManagement/CustomerRFQ/CURFQDetails";
import HomePage from "../../Home/HomePage";
import { FRfqList } from "../../AccountManagement/CustomerRFQ/FRfqList";
import { CURFQAssignedToMe } from "../../AccountManagement/CustomerRFQ/CURFQAssignedtome";
import StepperComponent from "../../AccountManagement/MmrfqForm/Stepper";
import { FileProvider } from "../../AccountManagement/MmrfqForm/FileContext";
import { AllMmrfq } from "../../AccountManagement/MmrfqForm/AllMmrfq";
import { MenualQuotation } from "../../AccountManagement/MmrfqForm/MenualQuotation";
import { QuoteCompareData } from "../../AccountManagement/MmrfqForm/QuoteCompareData";
import { MmrfqDetails } from "../../AccountManagement/MmrfqForm/MmrfqDetails";
import { Proposals } from "../../AccountManagement/Proposals/Proposals";
import { RbacData } from "../../Rbac/RbacData";
import { RolesDep } from "../../Rbac/RolesDep";
import ProposalDocument from "../../AccountManagement/Proposals/ProposalDocument";
import CoPoCreation from "../../AccountManagement/CoPo/CoPoCreation";
import { CoPoDatatable } from "../../AccountManagement/CoPo/CopoDatatable";
import { ViewCoPo } from "../../AccountManagement/CoPo/viewCoPo";
import { DroppedRfq } from "../../AccountManagement/CustomerRFQ/DroppedRfq";
// import { DownTimeScreen } from "../User_Login/DownTimeScreen";

interface HomeProps {
    activePage: string;
    setActivePage: (page: string) => void;
    updateIsReadStatus: boolean;
    setUpdateIsReadStatus: (value: boolean) => void;
    partner_Id?: string;
}

const Home: React.FC<HomeProps> = ({
    activePage,
    setActivePage,
    updateIsReadStatus,
    setUpdateIsReadStatus
}) => {
    // Dynamically render content based on activePage
    const renderContent = useMemo(() => {
        switch (activePage) {
            case "PartnerDatabase":
                return (
                    <PartnerDatabase
                        updateIsReadStatus={updateIsReadStatus}
                        setUpdateIsReadStatus={setUpdateIsReadStatus}
                    />
                );
            case "FRfqList":
                return <FRfqList />;
            case "CompanyRfq":
                return <CustomerRfqOR />;
            case "Dashboard":
                return <HomePage />;
            case "PartnerDetails":
                return <PartnerDetails />;
            case "OrgRepo":
                return <OrgRepo />;
            case "CustomerFeedback":
                return <CustomerFeedback />;
            case "Proposals":
                return <Proposals />;
            case "OrgProfilePage":
                return <OrgProfilePage />;
            case "CompanyProfilePage":
                return <CompanyProfilePage />;
            case "CURFQDetails":
                return <CURFQDetails />;
            case "CURFQAssignedToMe":
                return <CURFQAssignedToMe />;
            case "DroppedRfq":
                return <DroppedRfq />;
            case "AllMmrfq":
                return <AllMmrfq />;
            case "Rbac":
                return <RbacData />;
            case "MMRFQForm":
                return (
                    <FileProvider>
                        <StepperComponent />
                    </FileProvider>
                );
            case "MmrfqDetails":
                return <MmrfqDetails />;
            case "MenualQuotation":
                return <MenualQuotation />;
            case "QuoteCompareData":
                return <QuoteCompareData />;
            case "RolesDep":
                return <RolesDep />;
            case "ProposalDocument":
                return <ProposalDocument />;
            case "CoPoCreation":
                return <CoPoCreation />;
            case "CoPoDatatable":
                return <CoPoDatatable />;
            case "viewCoPo":
                return <ViewCoPo />;
            // case "DownTimeScreen":
            //   return <DownTimeScreen />;
            default:
                return (
                    <Typography variant="h4">404: Page Not Found</Typography>
                );
        }
    }, [activePage, updateIsReadStatus, setUpdateIsReadStatus]);

    return <Box sx={{ flexGrow: 1, p: 3 }}>{renderContent}</Box>;
};

export default Home;
